<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="歌曲名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="fetch">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="recordList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" width="80">
			</el-table-column>
			<el-table-column prop="name" label="名称" width="200">
			</el-table-column>
			<el-table-column prop="categoryId" label="分类" width="130" :formatter="formatCategory">
			</el-table-column>
			<el-table-column prop="singerName" label="歌手" width="100">
			</el-table-column>
			<el-table-column prop="fileName" label="文件" width="220">
				<template slot-scope="scope">
					<a :href="scope.row.url" target="_blank" class="buttonText">{{scope.row.fileName}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="fileSize" label="大小" width="100">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180">
			</el-table-column>
			<el-table-column label="操作" width="250" fixed="right">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :page-count="pageNo" :total="pageTotal" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="歌曲ID" prop="_id">
					<span>{{editForm._id}}</span>
				</el-form-item>
				<el-form-item label="歌曲名" prop="name">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="分类" prop="categoryId">
					<el-select v-model="editForm.categoryId" placeholder="请选择分类">
						<el-option v-for="(item, index) in categorys" :key="index" :label="item.name" :value="item._id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="歌手" prop="singerId">
					<el-row style="padding-bottom: 0px;">
						<el-col :span="20">
							<el-autocomplete
								class="el-input"
								v-model="editForm.singerName"
								:fetch-suggestions="searchSinger"
								placeholder="请输入歌手名"
								:trigger-on-focus="false"
								@select="handleSelect"
								@input="handleInputChanged">
							</el-autocomplete>
						</el-col>
						<el-col :span="4">
							<el-button 
								:disabled="editForm.singerId !== '' || editForm.singerName.trim().length == 0"
								class="add-button"
								:loading="addSingerLoading"
								@click="handelAddSingerName">
							添加歌手
							</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item label="mp3文件" prop="url">
					<el-upload
						:disabled="fileList.length > 0"
						:headers="headers"
						:auto-upload="true"
						:action="uploadUrl"
						accept="audio/mpeg"
						:file-list="fileList"
						:on-success="handleUploadSuccess"
						:on-error="handleUploadError"
						:limit="1">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">请上传mp3格式文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="文件大小" prop="fileSize">
					<span>{{editForm.fileSize}}</span>
				</el-form-item>
				<el-form-item label="MD5" prop="hasg">
					<span>{{editForm.hash}}</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
				<el-form-item label="歌曲名" prop="name">
					<el-input v-model="addForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="分类" prop="categoryId">
					<el-select v-model="addForm.categoryId" placeholder="请选择分类">
						<el-option v-for="(item, index) in categorys" :key="index" :label="item.name" :value="item._id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="歌手" prop="singerId">
					<el-row style="padding-bottom: 0px;">
						<el-col :span="20">
							<el-autocomplete
								class="el-input"
								v-model="addForm.singerName"
								:fetch-suggestions="searchSinger"
								placeholder="请输入歌手名"
								:trigger-on-focus="false"
								@select="handleSelect"
								@input="handleInputChanged">
							</el-autocomplete>
						</el-col>
						<el-col :span="4">
							<el-button 
								:disabled="addForm.singerId !== '' || addForm.singerName.trim().length == 0"
								class="add-button"
								:loading="addSingerLoading"
								@click="handelAddSingerName">
								添加歌手
							</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item label="文件" prop="url">
					<el-upload
						:headers="headers"
						:auto-upload="true"
						:action="uploadUrl"
						accept="audio/mpeg"
						:file-list="fileList"
						:on-success="handleUploadSuccess"
						:on-error="handleUploadError"
						:limit="1">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">请上传mp3格式文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="文件大小" prop="fileSize">
					<span>{{addForm.fileSize}}</span>
				</el-form-item>
				<el-form-item label="MD5" prop="hasg">
					<span>{{addForm.hash}}</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getSingerList, uploadUrl, getCategoryList, getMusicListPage, removeMusic, batchRemoveMusic, editMusic, addMusic, addSinger } from '../api/api';

	export default {
		data() {
			const token = sessionStorage.getItem('token')
			return {
				headers: { Authorization: `Bearer ${token}` },
				filters: {
					name: ''
				},
				recordList: [],
				fileList: [],
				categorys: [],
				pageTotal: 0,
				currentPage: 1,
				pageSize: 15,
				pageNo: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入歌曲名', trigger: 'blur' }
					],
					categoryId: [
						{ required: true, message: '请选择分类', trigger: 'blur' }
					],
					singerId: [
						{ required: true, message: '请填写歌手', trigger: 'blur' }
					],
					url: [
						{ required: true, message: '请上传文件', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					categoryId: '',
					url: '',
					fileName: '',
					hash: '',
					fileSize: '',
					singerId: '',
					singerName: '',
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入歌曲名', trigger: 'blur' }
					],
					categoryId: [
						{ required: true, message: '请选择分类', trigger: 'blur' }
					],
					singerId: [
						{ required: true, message: '请填写歌手', trigger: 'blur' }
					],
					url: [
						{ required: true, message: '请上传文件', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					name: '',
					categoryId: '',
					url: '',
					fileName: '',
					hash: '',
					fileSize: '',
					singerId: '',
					singerName: '',
				},
				uploadUrl: uploadUrl,
				addSingerLoading: false
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val;
				this.fetch();
			},
			//分类显示转换
			formatCategory: function (row, column) {
				const arr = this.categorys.filter(item => item._id === row.categoryId);
				if (arr && arr.length > 0) {
					return arr[0].name;
				} else {
					return '';
				}
			},
			//获取用户列表
			async fetch() {
				let para = {
					name: this.filters.name,
					currentPage: this.currentPage,
					pageSize: this.pageSize,
				};
				this.listLoading = true;
				//NProgress.start();
				const res = await getMusicListPage(para)
				this.listLoading = false;
				//NProgress.done();
				if (res.data.status !== 200) {
					this.$message({
					message: res.data.message,
					type: 'warning'
					});
					return
				}
				this.currentPage = res.data.data.currentPage;
				this.pageSize = res.data.data.pageSize;
				this.pageNo = res.data.data.pageNo;
				this.pageTotal = res.data.data.pageTotal;
				this.recordList = res.data.data.recordList;
			},
			//获取分类列表
			async getCateList() {
				const res = await getCategoryList()
				this.categorys = res.data.data.recordList;
			},
			handleInputChanged(val) {
				if (val.trim().length === 0) {
					if (this.addFormVisible) {
						this.addForm.singerId = ''
					} else if (this.editFormVisible) {
						this.editForm.singerId = ''
					}
				}
			},
			async searchSinger(name, callback) {
				if (name.trim().length === 0) {
					callback([])
				}

				const res = await getSingerList({ name })
				callback(res.data.data.recordList.map(item => {
					return { ...item, value: item.name };
				}))
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
				this.fileList = [{name: row.fileName, url: row.url}]
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					categoryId: '',
					url: '',
					hash: '',
					fileSize: '',
					singerId: '',
					singerName: '',
				};
				this.fileList = []
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate(async (valid) => {
					if (valid) {
						this.editLoading = true;
						//NProgress.start();
						const para = Object.assign({}, this.editForm);
						const res = await editMusic(para)
						this.editLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['editForm'].resetFields();
						this.editFormVisible = false;
						this.fetch();
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate(async (valid) => {
					if (valid) {
						this.addLoading = true;
						//NProgress.start();
						const para = Object.assign({}, this.addForm);
						const res = await addMusic(para)
						this.addLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['addForm'].resetFields();
						this.addFormVisible = false;
						this.fetch();
					}
				});
			},
			handleUploadSuccess: function(res, file) {
				if (this.addFormVisible) {
					this.addForm.url = res.data.url
					this.addForm.fileName = file.name
					this.addForm.hash = res.data.fields.hash
					this.addForm.fileSize = res.data.fields.fileSize
				} else if (this.editFormVisible) {
					this.editForm.url = res.data.url
					this.editForm.fileName = file.name
					this.editForm.hash = res.data.fields.hash
					this.editForm.fileSize = res.data.fields.fileSize
				}
			},
			handleUploadError: function(error) {
				console.log(error);
			},
			handleSelect(item) {
				if (this.addFormVisible) {
					this.addForm.singerId = item._id
					this.addForm.singerName = item.name
				} else if (this.editFormVisible) {
					this.editForm.singerId = item._id
					this.editForm.singerName = item.name
				}
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					const para = { id: row._id };
					const res = await removeMusic(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
						this.$message({
						message: res.data.message,
						type: 'warning'
						});
						return
					}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				const ids = this.sels.map(item => item._id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					const res = await batchRemoveMusic(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
						this.$message({
						message: res.data.message,
						type: 'warning'
						});
						return
					}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			},
			handelAddSingerName: async function() {
				this.addSingerLoading = true;
				//NProgress.start();
				let para = { name: this.editFormVisible ? this.editForm.singerName : this.addForm.singerName };
				const res = await addSinger(para)
				this.addSingerLoading = false;
				//NProgress.done();
				if (res.data.status !== 200) {
					this.$message({
					message: res.data.message,
					type: 'warning'
					});
					return
				}
				this.$message({
					message: '添加成功',
					type: 'success'
				});
				if (this.editFormVisible) {
					this.editForm.singerId = res.data.data._id
				} else {
					this.addForm.singerId = res.data.data._id
				}
			}
		},
		async mounted() {
			await this.getCateList();
			this.fetch();
		}
	}

</script>

<style lang="scss" scoped>
.add-button {
	margin-left: 8px;
}
</style>


// WEBPACK FOOTER //
// Music.vue?4bbea7f9